(() => {
  if (customElements.get('featured-collections')) {
    return;
  }

  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();

      this.collectionList = this.querySelector('[data-collections-list]');
      this.collectionImages = this.querySelector('[data-collections-images]');

      this.desktopMatchQuery = window.matchMedia('(min-width: 990px)');
    }

    connectedCallback() {
      this.handleResize();
    }

    handleResize() {
      window.addEventListener('resize', () => {
        if (!this.desktopMatchQuery.matches) {
          return;
        }
        this.attachEvents();
      })
    }

    attachEvents() {
      this.collectionList.querySelectorAll('a').forEach((link) => {
        link.addEventListener('mouseenter', this.setActiveImage.bind(this));
      });

      this.collectionList.addEventListener(
        'mouseleave',
        this.setDefaultImage.bind(this),
      );
    }

    setActiveImage(event) {
      const targetIndex = event.target.dataset.index;
      const targetImage = this.collectionImages.querySelector(
        `.featured-collections__image[data-index="${targetIndex}"]`,
      );
      const defaultImage = this.collectionImages.querySelector(
        '.featured-collections__image',
      );

      this.clearActiveState();

      if (!targetImage) {
        defaultImage.classList.add('is-active');

        return;
      }

      targetImage.classList.add('is-active');
    }

    setDefaultImage() {
      this.clearActiveState();

      this.collectionImages
        .querySelector('.featured-collections__image')
        ?.classList.add('is-active');
    }

    clearActiveState() {
      this.collectionImages
        .querySelectorAll('.featured-collections__image.is-active')
        .forEach((activeImage) => activeImage.classList.remove('is-active'));
    }
  }

  customElements.define('featured-collections', FeaturedCollections);
})();
